import { render } from "./EventList.vue?vue&type=template&id=4f45ea52"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=4f45ea52&lang=css"
script.render = render

export default script